<template>
  <div class="">GeoJson</div>
</template>

<script>
export default {
  name: 'GeoJson'
}
</script>

<style>

</style>